import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PaymentEntity } from 'src/app/shared';
import { SubSink } from 'subsink';

@Component({
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
})
export class ResultComponent implements OnInit {
  // -----------------------------Private properties|
  private subsink = new SubSink();

  // -----------------------------Public properties|
  public payment!: PaymentEntity;
  paymentId: string | null = '';
  paymentStatus: string | null = '';

  // -----------------------------Constructors|
  constructor(private activatedRoute: ActivatedRoute) {
    this.paymentId = this.activatedRoute.snapshot.paramMap.get('id');
    this.paymentStatus = this.activatedRoute.snapshot.paramMap.get('status');

    // this.subsink.sink = activatedRoute.data.subscribe((data) => {
    // this.payment = data['id'];
    // });
  }

  ngOnInit(): void {}

  // -----------------------------Public methods|

  // -----------------------------Private methods|
}
